export enum SyncActionStatusType {
  PENDING = "Pending",
  STARTED = "Started",
  FAILED = "Failed",
  COMPLETED = 'Completed'
}
